import React, { useEffect, useState } from "react";
import Body from "./components/Body";
import { StatsSummaryApp } from "@appsinti/common-utils/interfaces/IApp";
import IGroup from "@appsinti/common-utils/interfaces/IGroup";
import styled from "styled-components";
import { PreviewDataProvider } from "./data";
import { useViewport } from "@appsinti/viewport";

const MainContainer = styled.div<{ gap: number }>`
  height: 100%;
  min-height: 100%;
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  max-width: 100%;

  > .stats-summary-group-flex-container:not(:last-child) {
    margin-bottom: ${({ gap }) => gap}px;
  }

  &.row {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Preview: React.FC<{
  app: StatsSummaryApp;
  groups: { [key: number]: IGroup };
}> = ({ app, groups }) => {
  const [gap, setGap] = useState(10);
  const { height } = useViewport();

  useEffect(() => {
      if (height < 710) {
        setGap(4);
      } else if (height < 750) {
        setGap(6);
      } else {
        setGap(10);
      }
  }, [height]);

  return (
    <MainContainer className="stats-summary-main-container" gap={gap}>
      <PreviewDataProvider appId={app.id} groups={groups}>
        <Body
          app={app}
          groups={groups}
          gap={gap}
        />
      </PreviewDataProvider>
    </MainContainer>
  );
};

export default Preview;
